export const formConstants = {
    FORM_LOADING: 'FORM_LOADING',
    FORM_ERROR: 'FORM_ERROR',
    FORM_SENT: 'FORM_SENT',
    FORM_RESET: 'FORM_RESET'
};
